/* eslint-disable */
import FormGroup from '@material-ui/core/FormGroup'
import TextField from '@material-ui/core/TextField'
import Icon3 from '@material-ui/icons/ImportExport'
import alertifyjs from 'alertifyjs'
import jsPDF from 'jspdf'
import queryString from 'query-string'
import React, { Component } from 'react'
import { Accordion, Card } from 'react-bootstrap'
import DataTable, { createTheme } from 'react-data-table-component'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import { Button } from 'reactstrap'
import { bindActionCreators } from 'redux'
import * as changeNavigationAction from '../../../redux/actions/changeNavigationAction'
import * as classroomActions from '../../../redux/actions/classroomActions'
import * as schoolActions from '../../../redux/actions/schoolActions'
import initialState from '../../../redux/reducers/initialState'
import { ScrollView } from '../base/scroll'

class Classrooms extends Component {
	find_in_object(array1, my_criteria) {
		return array1.map((obj) => {
			if (obj.id === my_criteria) {
				return obj.schoolName
			}
		})
	}

	constructor(props) {
		super(props)

		this.state = {
			ActiveSchholId: '',

			schooldict: {},
			dataChart: [
				{
					name: 'Matematik',
					Adet: 5,
				},
				{
					name: 'İngilizce',
					Adet: 10,
				},
				{
					name: 'Almanca',
					Adet: 50,
				},
				{
					name: 'Fransızca',
					Adet: 20,
				},
			],

			ClassroomsColumns: [
				{
					name: 'Sınıf Adı',
					selector: 'className',
					sortable: true,
					width: '75px',
				},
				{
					name: 'Okul',
					selector: 'schoolId',
					sortable: true,
					left: true,
					cell: (row) =>
						this.find_in_object(this.props.schoolReducerData.extra, row.schoolId),
				},
				{
					name: 'Öğretmen',
					selector: 'teachers',
					sortable: true,
					left: true,
					cell: (row) => row.teachers.map((t) => t.fullName).join(', '),
				},
				{
					name: 'Öğrenci Sayısı',
					selector: 'studentCount',
					sortable: true,
					left: true,
					width: '50px',
				},
				{
					name: 'Aktiflik',
					selector: 'isActive',
					sortable: true,
					right: true,
					cell: (row) => (row.isActive === true ? 'Aktif' : 'Pasif'),
					width: '75px',
				},
				{
					cell: (row) => (
						<Link
							className="btn btn-dark"
							to={{
								pathname: '/ClassroomDetails',
								state: {
									roleid: '31C0D3DB-722F-430B-9031-029C15A794AD',
									...row,
								},
							}}
						>
							Detaylar
						</Link>
					),
					ignoreRowClick: true,
					allowOverflow: true,
					button: true,
					width: '95px',
				},
				{
					cell: (row) =>
						this.props.userAuthData.permissions.includes(
							initialState.staticPerms.AssignLessonToClass
						) == true ? (
								<Button
									color="light"
									onClick={() => this.goToClassLesson(row, 'ToClassLesson')}
								>
								Ders Ata
								</Button>
							) : null,
					ignoreRowClick: true,
					allowOverflow: true,
					button: true,
					width:
						this.props.userAuthData.permissions.includes(
							initialState.staticPerms.AssignLessonToClass
						) == true
							? '95px'
							: '0px',
				},

				{
					cell: (row) =>
						this.props.userAuthData.permissions.includes(
							initialState.staticPerms.CanAddTeacher
						) == true ? (
								<Button
									color="secondary"
									onClick={() => this.onRowClickAddStudentOrTeacher(row, 'ToClass', 'teacher')}
								>
								Öğretmen Ata
								</Button>
							) : null,
					ignoreRowClick: true,
					allowOverflow: true,
					button: true,
					width:
						this.props.userAuthData.permissions.includes(
							initialState.staticPerms.CanAddTeacher
						) == true
							? '135px'
							: '0px',
				},
				{
					cell: (row) =>
						this.props.userAuthData.permissions.includes(
							initialState.staticPerms.UpdateClassroom
						) == true ? (
								<Button
									color="info"
									onClick={() => this.onRowClickAddStudentOrTeacher(row, 'ToClass', 'student')}
								>
								Öğrenci Ata
								</Button>
							) : null,
					ignoreRowClick: true,
					allowOverflow: true,
					button: true,
					width:
						this.props.userAuthData.permissions.includes(
							initialState.staticPerms.UpdateClassroom
						) == true
							? '120px'
							: '0px',
				},
				{
					cell: (row) =>
						this.props.userAuthData.permissions.includes(
							initialState.staticPerms.UpdateClassroom
						) == true ? (
								<Button
									color="warning"
									onClick={() => this.onRowClickUpdate(row, 'AddOrUpdateClassrooms')}
								>
								Güncelle
								</Button>
							) : null,
					ignoreRowClick: true,
					allowOverflow: true,
					button: true,
					width:
						this.props.userAuthData.permissions.includes(
							initialState.staticPerms.UpdateClassroom
						) == true
							? '95px'
							: '0px',
				},

				{
					cell: (row) =>
						this.props.userAuthData.permissions.includes(
							initialState.staticPerms.DeleteClassroom
						) === true ? (
								<Button color="danger" onClick={() => this.onDeleteClick(row)}>
								Sil
								</Button>
							) : null,
					ignoreRowClick: true,
					allowOverflow: true,
					button: true,
					width:
						this.props.userAuthData.permissions.includes(
							initialState.staticPerms.DeleteClassroom
						) == true
							? '50px'
							: '0px',
				},
			],

			FullClassroomsColumns: [
				{
					name: 'Sınıf Adı',
					selector: 'className',
					sortable: true,
					width: '10rem',
				},
				{
					name: 'Okul',
					selector: 'schoolId',
					sortable: true,
					left: true,
					width: '10rem',
					cell: (row) =>
						this.find_in_object(this.props.schoolReducerData.extra, row.schoolId),
				},
				{
					name: 'Öğretmen',
					selector: 'teachers',
					sortable: true,
					left: true,
					cell: (row) => row.teachers.map((t) => t.fullName).join(', '),
				},
				{
					name: 'Öğrenci Sayısı',
					selector: 'studentCount',
					sortable: true,
					left: true,
					width: '150px',
				},
				{
					name: 'Aktiflik',
					selector: 'isActive',
					sortable: true,
					right: true,
					cell: (row) => (row.isActive === true ? 'Aktif' : 'Pasif'),
				},
				{
					cell: (row) => (
						<Link
							className="btn btn-dark"
							to={{
								pathname: '/ClassroomDetails',
								state: {
									roleid: '31C0D3DB-722F-430B-9031-029C15A794AD',
									...row,
								},
							}}
						>
							Detaylar
						</Link>
					),
					ignoreRowClick: true,
					allowOverflow: true,
					button: true,
					width: '95px',
				},
				{
					cell: (row) =>
						this.props.userAuthData.permissions.includes(
							initialState.staticPerms.AssignLessonToClass
						) == true ? (
								<Button
									color="light"
									onClick={() => this.goToClassLesson(row, 'ToClassLesson')}
								>
								Ders Ata
								</Button>
							) : null,
					ignoreRowClick: true,
					allowOverflow: true,
					button: true,
					width:
						this.props.userAuthData.permissions.includes(
							initialState.staticPerms.AssignLessonToClass
						) == true
							? '95px'
							: '0px',
				},

				{
					cell: (row) =>
						this.props.userAuthData.permissions.includes(
							initialState.staticPerms.CanAddTeacher
						) == true ? (
								<Button
									color="secondary"
									onClick={() => this.onRowClickAddStudentOrTeacher(row, 'ToClass', 'teacher')}
								>
								Öğretmen Ata
								</Button>
							) : null,
					ignoreRowClick: true,
					allowOverflow: true,
					button: true,
					width:
						this.props.userAuthData.permissions.includes(
							initialState.staticPerms.CanAddTeacher
						) == true
							? '135px'
							: '0px',
				},
				{
					cell: (row) =>
						this.props.userAuthData.permissions.includes(
							initialState.staticPerms.UpdateClassroom
						) == true ? (
								<Button
									color="info"
									onClick={() => this.onRowClickAddStudentOrTeacher(row, 'ToClass', 'student')}
								>
								Öğrenci Ata
								</Button>
							) : null,
					ignoreRowClick: true,
					allowOverflow: true,
					button: true,
					width:
						this.props.userAuthData.permissions.includes(
							initialState.staticPerms.UpdateClassroom
						) == true
							? '120px'
							: '0px',
				},
				{
					cell: (row) =>
						this.props.userAuthData.permissions.includes(
							initialState.staticPerms.UpdateClassroom
						) == true ? (
								<Button
									color="warning"
									onClick={() => this.onRowClickUpdate(row, 'AddOrUpdateClassrooms')}
								>
								Güncelle
								</Button>
							) : null,
					ignoreRowClick: true,
					allowOverflow: true,
					button: true,
					width:
						this.props.userAuthData.permissions.includes(
							initialState.staticPerms.UpdateClassroom
						) == true
							? '95px'
							: '0px',
				},

				{
					cell: (row) =>
						this.props.userAuthData.permissions.includes(
							initialState.staticPerms.FullDeleteClassroom
						) == true ? (
								<Button color="danger" onClick={() => this.onFullDeleteClick(row)}>
								F-Sil
								</Button>
							) : null,
					ignoreRowClick: true,
					allowOverflow: true,
					button: true,
					width:
						this.props.userAuthData.permissions.includes(
							initialState.staticPerms.FullDeleteClassroom
						) == true
							? '65px'
							: '0px',
				},
			],
		}
	}

	componentWillMount() {
		const values = queryString.parse(this.props.location.search)
		this.setState({ ActiveSchholId: values.Id })

		this.props.actions.getSchool()

		this.props.actions.getClassroom()
		this.props.actions.getFullClassroom()
	}

	componentDidMount() {}

	exportPDF = (dataGElen) => {
		const unit = 'pt'
		const size = 'A4' // Use A1, A2, A3 or A4
		const orientation = 'portrait' // portrait or landscape

		const marginLeft = 40
		const doc = new jsPDF(orientation, unit, size)

		doc.setFontSize(10)

		const title = 'SINIF RAPORLAMALARI'
		const headers = [['SINIF ADI', 'OKUL ADI']]

		const data = dataGElen.map((elt) => [
			elt.className,
			this.find_in_object(this.props.schoolReducerData.extra, elt.schoolId),
		])

		let content = {
			startY: 50,
			head: headers,
			body: data,
		}

		doc.text(title, marginLeft, 40)
		doc.autoTable(content)
		doc.save('report.pdf')
	}

	setSchoolnameDict() {
		var schooldict = {}

		this.props.fullClassrooms.extra.map((classroom) => {
			var schoolName = this.props.schoolReducerData.extra.filter(
				(school) => school.id === classroom.schoolId
			)
			schooldict[schoolName[0].id] = schoolName[0].schoolName
		})

		this.setState({ schooldict: schooldict })
	}

	componentWillReceiveProps(newProps) {
		if (newProps.classrooms.success === true) {
			if (this.state.ActiveSchholId === undefined) {
				this.setState({ classroomlListData_onQuery: newProps.classrooms.extra })
			} else {
				var new1 = newProps.classrooms.extra.filter((aa) => {
					return aa.schoolId === this.state.ActiveSchholId
				})
				this.setState({ classroomlListData_onQuery: new1 })
			}
			this.props.actions.changeDeletedClassroomSuccessStatus('')
			this.props.actions.resetAllStatuss('')
		}

		if (newProps.fullClassrooms.success === true) {
			if (this.state.ActiveSchholId === undefined) {
				this.setState({
					classroomFullListData_onQuery: newProps.fullClassrooms.extra,
				})
			} else {
				var new2 = newProps.fullClassrooms.extra.filter((aa) => {
					return aa.schoolId === this.state.ActiveSchholId
				})
				this.setState({ classroomFullListData_onQuery: new2 })
			}

			this.props.actions.changeDeletedClassroomSuccessStatus('')
			this.props.actions.resetFullStatussClassrooms('')
		}

		if (newProps.classrooms.deleted) {
			alertifyjs.success('Sınıf Başarılı Olarak Silindi!')
			newProps.actions.changeDeletedClassroomSuccessStatus('')
			newProps.actions.resetAllStatuss('')
			newProps.actions.getClassroom()
			newProps.actions.getFullClassroom()
		} else if (newProps.classrooms.deleted === false) {
			alertifyjs.error('Sınıf Silinirken Hatalar Oluştu.')
			newProps.actions.changeDeletedClassroomSuccessStatus('')
			newProps.actions.resetAllStatuss('')
		}
	}

	selectNavigation = (navigation) => {
		this.props.actions.changeDeletedClassroomSuccessStatus('')
		this.props.actions.resetAllStatuss('')

		var location = {
			pathname: navigation,
		}

		this.props.history.push(location)
	}

	searchOnList = (e) => {
		this.setState({ [e.target.name]: e.target.value })

		if (e.target.value) {
			var classroomlListData_onQuery = this.props.classrooms.extra.filter((item) =>
				item.className.like(e.target.value)
			)
			this.setState({ classroomlListData_onQuery })
		} else {
			this.setState({ classroomlListData_onQuery: this.props.classrooms.extra })
		}
	}

	searchOnFullList = (e) => {
		this.setState({ [e.target.name]: e.target.value })

		if (e.target.value) {
			var classroomFullListData_onQuery = this.props.fullClassrooms.extra.filter(
				(item) => item.className.like(e.target.value)
			)
			this.setState({ classroomFullListData_onQuery })
		} else {
			this.setState({
				classroomFullListData_onQuery: this.props.fullClassrooms.extra,
			})
		}
	}

	handleClick = (state) => {}

	onRowClickUpdate = (row, navigation) => {
		var location = {
			pathname: navigation,
			state: {
				data: row,
				actionType: 'update',
			},
		}

		this.props.history.push(location)
	}

	onRowClickClassroomDetails = (row, navigation) => {
		return (
			<Link
				ref={(ref) => ref.click()}
				to={{
					pathname: `${navigation}?i=${row.id}`,
					state: {
						data: row,
						actionType: 'ClassroomDetails',
						roleid: '31C0D3DB-722F-430B-9031-029C15A794AD',
					},
				}}
			/>
		)
	}

	goToClassLesson = (row, navigation) => {
		var location = {
			pathname: navigation,
			state: {
				data: row,
				actionType: 'toClassLesson',
				roleid: '63E57874-82D0-4658-9EB5-AE5C93906DB2',
			},
		}
		this.props.history.push(location)
	}

	onRowClickAddStudentOrTeacher = (row, navigation, type) => {
		if (type === 'teacher') {
			var location = {
				pathname: navigation,
				state: {
					data: row,
					actionType: 'toClassTeacher',
					roleid: '63E57874-82D0-4658-9EB5-AE5C93906DB2',
				}
			}
		} else {
			var location = {
				pathname: navigation,
				state: {
					data: row,
					actionType: 'toClassStudent',
					roleid: '31C0D3DB-722F-430B-9031-029C15A794AD',
				},
			}
		}

		this.props.history.push(location)
	}

	onDeleteClick = (state) => {
		if (confirm('Silmek istediğinize emin misiniz?')) {
			var data = { id: state.id }
			this.props.actions.deleteClassroom(data)
		}
	}

	onFullDeleteClick = (state) => {
		if (confirm('Silmek istediğinize emin misiniz?')) {
			var data = { id: state.id }
			this.props.actions.fullDeleteClassroom(data)
		}
	}

	renderRolesList() {
		return (
			<Card>
				<Accordion.Toggle eventKey="0" as={Card.Header}>
					<div className="d-flex justify-content-between">
						<FormGroup row>
							<h4>Sınıflar</h4>
						</FormGroup>

						<FormGroup row>
							<Icon3 style={{ margin: '5px' }} color="action" />
						</FormGroup>
					</div>
				</Accordion.Toggle>

				<Accordion.Collapse eventKey="0">
					<DataTable
						columns={this.state.ClassroomsColumns}
						data={this.state.classroomlListData_onQuery}
						pagination
						noHeader
						highlightOnHover
						progressPending={this.props.classrooms.extra.length > 0 ? false : true}
						subHeader
						subHeaderComponent={
							<div style={{ display: 'flex', alignItems: 'center' }}>
								{this.props.userAuthData.permissions.includes(
									initialState.staticPerms.AddClassroom
								) === true ? (
										<button
											type="button"
											className="btn btn-outline-success"
											onClick={() => this.selectNavigation('AddOrUpdateClassrooms')}
										>
											<i className="fa fa-plus"></i>
										</button>
									) : null}

								{this.props.userAuthData.permissions.includes(
									initialState.staticPerms.FindClassroom
								) === true ? (
										<TextField
											onChange={this.searchOnList}
											id="outlined-basic"
											label="Arama"
											variant="outlined"
											size="small"
											style={{ margin: '5px' }}
										/>
									) : null}
								<i
									className="fa fa-file-pdf-o fa-2x"
									onClick={() => this.exportPDF(this.state.classroomlListData_onQuery)}
								/>
							</div>
						}
						subHeaderAlign={'left'}
						fixedHeader={false}
						fixedHeaderScrollHeight="300px"
					/>
				</Accordion.Collapse>
			</Card>
		)
	}

	renderFullList() {
		return (
			<Card>
				<Accordion.Toggle eventKey="1" as={Card.Header}>
					<div className="d-flex justify-content-between">
						<FormGroup row>
							<h4>Full Sınıflar</h4>
						</FormGroup>

						<FormGroup row>
							<Icon3 style={{ margin: '5px' }} color="action" />
						</FormGroup>
					</div>
				</Accordion.Toggle>

				<Accordion.Collapse eventKey="1">
					<DataTable
						columns={this.state.FullClassroomsColumns}
						data={this.state.classroomFullListData_onQuery}
						pagination
						highlightOnHover
						progressPending={this.props.fullClassrooms.extra.length > 0 ? false : true}
						subHeader
						noHeader
						subHeaderComponent={
							<div style={{ display: 'flex', alignItems: 'center' }}>
								{this.props.userAuthData.permissions.includes(
									initialState.staticPerms.AddClassroom
								) === true ? (
										<button
											type="button"
											className="btn btn-outline-success"
											onClick={() => this.selectNavigation('AddOrUpdateClassrooms')}
										>
											<i className="fa fa-plus"></i>
										</button>
									) : null}

								{this.props.userAuthData.permissions.includes(
									initialState.staticPerms.FindFullListClassroom
								) === true ? (
										<TextField
											onChange={this.searchOnFullList}
											id="outlined-basic"
											label="Arama"
											variant="outlined"
											size="small"
											style={{ margin: '5px' }}
										/>
									) : null}

								<i
									className="fa fa-file-pdf-o fa-2x"
									onClick={() => this.exportPDF(this.state.classroomFullListData_onQuery)}
								/>
							</div>
						}
						subHeaderAlign={'left'}
						fixedHeader={false}
						fixedHeaderScrollHeight="300px"
					/>
				</Accordion.Collapse>
			</Card>
		)
	}

	render() {
		createTheme('solarized', {
			text: {
				primary: '#268bd2',
				secondary: '#2aa198',
			},
			background: {
				default: '#002b36',
			},
			context: {
				background: '#cb4b16',
				text: '#FFFFFF',
			},
			divider: {
				default: '#073642',
			},
			action: {
				button: 'rgba(0,0,0,.54)',
				hover: 'rgba(0,0,0,.08)',
				disabled: 'rgba(0,0,0,.12)',
			},
		})

		return (
			<ScrollView>
				<div className="row">
					<div className="col-lg-12">
						<Accordion defaultActiveKey="0">
							{this.props.userAuthData.permissions.includes(
								initialState.staticPerms.FullListClassroom
							) === true
								? this.renderFullList()
								: null}

							{this.props.userAuthData.permissions.includes(
								initialState.staticPerms.ListClassroom
							) === true
								? this.renderRolesList()
								: null}
						</Accordion>
					</div>
				</div>
			</ScrollView>
		)
	}
}

function mapStateToProps(state) {
	return {
		toggleStatus: state.toggleReducer,
		userAuthData: state.authReducer,
		currentNavigation: state.changeNavigationReducer,
		classrooms: state.classroomReducer,
		fullClassrooms: state.fullClassroomReducer,
		schoolReducerData: state.schoolReducer,
	}
}

function mapDispatchToProps(dispatch) {
	return {
		actions: {
			changeNavigation: bindActionCreators(
				changeNavigationAction.changeNavigation,
				dispatch
			),
			getSchool: bindActionCreators(schoolActions.getSchool, dispatch),

			getClassroom: bindActionCreators(classroomActions.getClassroom, dispatch),

			getFullClassroom: bindActionCreators(classroomActions.getFullClassroom, dispatch),
			resetFullStatussClassrooms: bindActionCreators(
				classroomActions.resetFullStatussClassrooms,
				dispatch
			),
			deleteClassroom: bindActionCreators(classroomActions.deleteClassroom, dispatch),
			fullDeleteClassroom: bindActionCreators(
				classroomActions.fullDeleteClassroom,
				dispatch
			),
			createClassroom: bindActionCreators(classroomActions.createClassroom, dispatch),
			setClassroomRegStatuss: bindActionCreators(
				classroomActions.setClassroomRegStatuss,
				dispatch
			),
			changeDeletedClassroomSuccessStatus: bindActionCreators(
				classroomActions.changeDeletedClassroomSuccessStatus,
				dispatch
			),
			resetAllStatuss: bindActionCreators(classroomActions.resetAllStatuss, dispatch),
		},
	}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Classrooms))
